import { render } from "./NewAsideInmetAviso.vue?vue&type=template&id=8c3c4098&scoped=true"
import script from "./NewAsideInmetAviso.vue?vue&type=script&lang=js"
export * from "./NewAsideInmetAviso.vue?vue&type=script&lang=js"

import "./NewAsideInmetAviso.vue?vue&type=style&index=0&id=8c3c4098&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3c4098"]])

export default __exports__